<template>
  <div class="column">
    <Del v-if="page == 'del'"></Del>
  </div>
</template>

<script>
import Del from './pages/Del.vue'

export default {
  name: 'SideView',
  data () {
    return {
      page: this.config.name
    }
  },

  mounted() {
  	
  },

  components: {
    Del
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SideView.vue